export default "__VITE_ASSET__Dmqb9HAq__"